import React from 'react'
import palette from 'src/designSystem/variables/palette'
import { PillContainer, CloseIcon } from './Pill.styles'
import { DarkenColor } from './Pill.helper'

export interface PillProps {
  label: React.ReactNode
  backgroundColor?: string
  useBorder?: boolean
  borderOnly?: boolean
  borderColor?: string
  $fontColor?: string
  $height?: string
  $width?: string
  $size?: 'small' | 'medium' | 'large'
  isCloseable?: boolean
  fontSize?: string
  closeIconSize?: string
  onClose?: (e: React.MouseEvent<HTMLDivElement>) => void
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  'data-testid'?: string
}

export const Pill = ({
  label,
  backgroundColor,
  useBorder,
  borderOnly,
  borderColor,
  $height,
  $fontColor,
  $width,
  $size,
  isCloseable,
  fontSize,
  closeIconSize,
  onClose,
  onClick,
  'data-testid': dataTestId,
}: PillProps): JSX.Element => {
  return (
    <PillContainer
      data-testid={dataTestId}
      onClick={onClick}
      style={{
        backgroundColor: borderOnly ? 'transparent' : backgroundColor,
        height: $height,
        width: $width,
        border: useBorder
          ? `1px solid ${
              borderColor ||
              (backgroundColor
                ? DarkenColor(backgroundColor || '#000', 40)
                : palette.neutral[100])
            }`
          : 'none',
        fontSize:
          fontSize ||
          ($size === 'small' ? '12px' : $size === 'medium' ? '14px' : '16px'),
        fontWeight: 400,
        color: $fontColor || undefined,
      }}
    >
      {label}
      {isCloseable && (
        <div onClick={onClose}>
          <CloseIcon
            style={
              closeIconSize
                ? { width: closeIconSize, height: closeIconSize }
                : undefined
            }
          />
        </div>
      )}
    </PillContainer>
  )
}
